export default {"src":"/_next/static/media/walking-bridge-lg.colour.9ff9c0ac.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};